import React from 'react';

const LoginBanner = () => (
  <div className='applogin-banner'>
    <div className='applogin-background' />
    <div className='applogin-container'>
      <h2>
        Connecting to <span className='inline-flex' style={{fontSize: '62px'}}>{`Message Runner`}</span>
      </h2>
      <p>Sign-in with your Les Schwab account to access LS</p>
    </div>
  </div>
);
export default LoginBanner;

LoginBanner.propTypes = {};
